import { BACCARAT_BET_TYPES as BET_TYPES } from '@ezugi/constants';

import {
  NATURAL_WIN,
  NON_NATURAL_WIN_BY_NINE_POINTS,
  NON_NATURAL_WIN_BY_EIGHT_POINTS,
  NON_NATURAL_WIN_BY_SIX_SEVEN_POINTS,
  NON_NATURAL_WIN_BY_FOUR_FIVE_POINTS,
} from './strings';

export const CLASSIC_OTT_PAYOUTS_BO_INDEX_MAP = {
  1: BET_TYPES.PLAYER,
  5: BET_TYPES.TIE,
  2: BET_TYPES.BANKER,
  7: BET_TYPES.PLAYER_PAIR,
  8: BET_TYPES.BANKER_PAIR,
  6: BET_TYPES.PERFECT_PAIR,
  9: BET_TYPES.EITHER_PAIR,
  11: BET_TYPES.SMALL,
  10: BET_TYPES.BIG,
  37: BET_TYPES.PLAYER_OVER,
  39: BET_TYPES.BANKER_OVER,
  38: BET_TYPES.PLAYER_UNDER,
  40: BET_TYPES.BANKER_UNDER,
};

export const NO_COMISSION_PAYOUTS_BO_INDEX_MAP = {
  1: BET_TYPES.PLAYER,
  5: BET_TYPES.TIE,
  2: BET_TYPES.BANKER,
  7: BET_TYPES.PLAYER_PAIR,
  8: BET_TYPES.BANKER_PAIR,
  6: BET_TYPES.PERFECT_PAIR,
  9: BET_TYPES.EITHER_PAIR,
  11: BET_TYPES.SMALL,
  10: BET_TYPES.BIG,
  37: BET_TYPES.PLAYER_OVER,
  39: BET_TYPES.BANKER_OVER,
  38: BET_TYPES.PLAYER_UNDER,
  40: BET_TYPES.BANKER_UNDER,
};

export const SUPER_SIX_PAYOUTS_BO_INDEX_MAP = {
  1: BET_TYPES.PLAYER,
  5: BET_TYPES.TIE,
  2: BET_TYPES.BANKER,
  18: BET_TYPES.SUPER_SIX,
};

export const DRAGON_BONUS_PAYOUTS_BO_INDEX_MAP = {
  1: BET_TYPES.PLAYER,
  5: BET_TYPES.TIE,
  2: BET_TYPES.BANKER,
  3001: NATURAL_WIN,
  3005: NON_NATURAL_WIN_BY_FOUR_FIVE_POINTS,
  3004: NON_NATURAL_WIN_BY_SIX_SEVEN_POINTS,
  3003: NON_NATURAL_WIN_BY_EIGHT_POINTS,
  3002: NON_NATURAL_WIN_BY_NINE_POINTS,
};

export const KNOCKOUT_PAYOUTS_BO_INDEX_MAP = {
  1: BET_TYPES.PLAYER,
  5: BET_TYPES.TIE,
  2: BET_TYPES.BANKER,
  13: BET_TYPES.NATURAL_PLAYER,
  14: BET_TYPES.NATURAL_BANKER,
  3001: NATURAL_WIN,
  1001: BET_TYPES.TOTALS_1_TO_4,
  1002: BET_TYPES.TOTALS_5_TO_6,
  1003: BET_TYPES.TOTALS_7,
  1004: BET_TYPES.TOTALS_8,
  1005: BET_TYPES.TOTALS_9,
};

export const DRAGON_TIGER_PAYOUTS_BO_INDEX_MAP = {
  3: BET_TYPES.DRAGON,
  4: BET_TYPES.TIGER,
  2003: BET_TYPES.TIE,
  2004: BET_TYPES.SUITED_TIE,
};

export const CRICKET_WAR_PAYOUTS_BO_INDEX_MAP = {
  2001: BET_TYPES.BOWLER,
  2002: BET_TYPES.BATSMAN,
  2003: BET_TYPES.TIE,
  2004: BET_TYPES.SUITED_TIE,
};
